import { Routes } from '@angular/router';

import { ShellComponent } from './layout/shell.component';
import { authGuard } from './core/auth/guards/auth.guard';
import { roleGuard } from './core/auth/guards/role.guard';
import { ADMIN_ROLES, MANAGEMENT_ROLES } from './core/auth/roles';

export const routes: Routes = [
	{
		path: '',
		component: ShellComponent,
		canActivate: [authGuard],
		children: [
			// Pagina de entrada tras iniciar sesion (AuthService navega a '/').
			// Top 100 es la unica visible para todos los roles: Entidades esta
			// restringida y un Operador aterrizaba ahi solo para que el guard lo
			// rebotara con un aviso de "sin permiso".
			{ path: '', pathMatch: 'full', redirectTo: 'top100' },
			{
				path: 'usuarios',
				canActivate: [roleGuard],
				data: { roles: MANAGEMENT_ROLES },
				loadComponent: () => import('./features/users/users.page').then((m) => m.UsersPage)
			},
			{
				path: 'top100',
				loadComponent: () => import('./features/top100/top100').then((m) => m.Top100)
			},
			{
				path: 'top100-summary',
				loadComponent: () =>
					import('./features/top100-summary/top100-summary').then((m) => m.Top100Summary)
			},
			{
				path: 'bodegas',
				canActivate: [roleGuard],
				data: { roles: ADMIN_ROLES },
				loadComponent: () => import('./features/bodegas/bodegas').then((m) => m.Bodegas)
			},
			{
				path: 'entidades',
				canActivate: [roleGuard],
				data: { roles: MANAGEMENT_ROLES },
				loadComponent: () => import('./features/entities/entities').then((m) => m.Entities)
			}

		]
	},
	{
		path: 'callback',
		loadComponent: () =>
			import('./core/auth/components/auth-callback/auth-callback.component').then(
				(m) => m.AuthCallbackComponent
			)
	},
	{ path: '**', redirectTo: 'top100' }
];
